import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import PageHeader from "../components/PageHeader";
import Section from "../components/Section";
import SectionGroup from "../components/SectionGroup";

export default function FaqPage() {
  return (
    <PageLayout maxWidth="standard">
      <PageHeader 
        title="FAQ"
        subtitle="Frequently Asked Questions… and a few we made up"
      />

      <SectionGroup>
        <Section title="What *is* ORO MOVE, exactly?">
          <p>
            ORO MOVE<sup>™</sup> is a simple, fast, not-trying-to-be-Social-Media tool for running and cycling clubs.
            We help you create events, manage members, keep chats sane, and basically avoid duct-taping together five apps just to go on a group run.
            Think: <strong className="text-text-primary">community without chaos.</strong>
          </p>
        </Section>

        <Section title="Is ORO MOVE free?">
          <p>Yes.</p>
          <p>And no.</p>
          <p>The base app is free for everyone.</p>
          <p>Clubs can upgrade if they want fancy stuff, bigger storage, or simply want to support the platform so we can keep the servers warm and the engineers caffeinated.</p>
        </Section>

        <Section title="Do you sell my data?">
          <p>Hard no.</p>
          <p>We're here to help your club move, not to auction off your shoe size and preferred electrolyte flavor to "trusted partners."</p>
          <p>Your data stays yours. Always.</p>
        </Section>

        <Section title="Why do you need my location sometimes?">
          <p>If you check in at an event, we make sure you're <em>actually there</em> and not heroically checking in from your couch.</p>
          <p>We don't store your coordinates — the moment we verify "yep, you're here," the location disappears into the void.</p>
        </Section>

        <Section title="What devices does ORO MOVE work on?">
          <p>If it has a browser, you're good.</p>
          <p>Phone, tablet, laptop, smart fridge… we don't judge.</p>
          <p>Native apps are coming, but for now the web version is slick, fast, and does everything you need.</p>
        </Section>

        <Section title="Can I use ORO MOVE for a cycling club? (Or a pickleball squad? A unicycle gang?)">
          <p>Absolutely.</p>
          <p>Two wheels, one wheel, no wheels — we support it.</p>
          <p>If you move through space and enjoy doing it with others, ORO MOVE<sup>™</sup> is your app.</p>
          <p>Want a feature added to support it? <Link to="/contact" className="underline">Get in touch</Link>.</p>
        </Section>

        <Section title="Does ORO MOVE track my runs or rides?">
          <p>Nope.</p>
          <p>We're not trying to replace your GPS watch or your ego-boosting mileage charts.</p>
          <p>We focus on <strong className="text-text-primary">community</strong>, not performance metrics.</p>
          <p>(That comes later. Probably. Maybe. Don't worry about it.)</p>
        </Section>

        <Section title="Why does the UI feel so minimal? Where is everything? WHERE IS THE FEED?!">
          <p>Because you don't need a digital yard sale to find your next event.</p>
          <p>ORO MOVE<sup>™</sup> keeps things intentionally clean so you can get to the good stuff without wading through seventeen buttons and a regret-filled Feed. Minimal isn't "missing" — it's focus. It's calm. It's oxygen.</p>
          <p><strong className="text-text-primary">And the Feed?</strong><br />No thanks. Doom-scrolling is death.<br />Group movement is L I F E.</p>
          <p>See you outside!</p>
        </Section>

        <Section title="Can I create multiple clubs?">
          <p>Yes.</p>
          <p>We won't stop you.</p>
          <p>Become the commissioner of your local Run Empire.</p>
          <p>Just remember: every new club increases your group chat responsibilities.</p>
        </Section>

        <Section title="Help! My club members won't RSVP.">
          <p>We can't fix that.</p>
          <p>We <em>do</em> give them obvious RSVP buttons, though.</p>
          <p>Peer pressure usually works better than technology.</p>
        </Section>

        <Section title="Is there a dark mode?">
          <p>There is only Nightfall.</p>
          <p>The app launches <em>in</em> dark mode.</p>
          <p>Light mode comes later, once we stop arguing about it.</p>
        </Section>

        <Section title="What if I break something?">
          <p>Message us.</p>
          <p>We're nice, and we probably broke it first anyway.</p>
        </Section>

        <Section title="Who built ORO MOVE?" showDivider={false}>
          <p>A tiny crew of Appalachian yucks who love long runs, mountain air, and questionable amounts of plantains on their steak fajitas.</p>
          <p>We make simple tools that help people get moving — together, on purpose.</p>
          <p>We're proud of this thing.</p>
          <p>We hope you will be too.</p>
        </Section>
      </SectionGroup>
    </PageLayout>
  );
}